var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"odd-router-loader"},[_c('span',{staticClass:"el-icon-loading"}),_vm._v(" Выполняется построение маршрута... ")])
}]

export { render, staticRenderFns }